import { render, staticRenderFns } from "./ComboTreeDepartment.vue?vue&type=template&id=0ebecf56&"
import script from "./ComboTreeDepartment.vue?vue&type=script&lang=js&"
export * from "./ComboTreeDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports